import type { TenantBranding, TenantFeatures } from '@services/tenantConfig.types';
import { useTenantConfigContext } from '@providers/TenantConfigProvider';

export type CustomerContextValue = {
  branding: TenantBranding;
  features: TenantFeatures;
};

/**
 * Read-only bridge to the tenant's branding + feature flags.
 *
 * Backed by TenantConfigProvider's context, so it returns the Novus defaults
 * before the `/tenantConfig` fetch resolves — and also when a component is
 * rendered outside the provider (e.g. in unit tests), which keeps consumers
 * safe without a hard throw.
 */
export const useCustomer = (): CustomerContextValue => {
  const { branding, features } = useTenantConfigContext();
  return { branding, features };
};
